import { Chip } from '@mui/material';
import type { MouseEventHandler } from 'react';
import classSet from 'react-classset';
import { Link } from 'react-router-dom';

import { Permission } from '../../enums';
import type { Item } from '../../models';
import type { Permissions } from '../../models/Permissions';

export interface Iprops {
  item: Item;
  permissions: Permissions;
  onClick?: MouseEventHandler<any>;
  href?: string;
}

const FuelAssetTitle = ({ item, permissions, onClick, href }: Iprops) => {
  const Component = href ? Link : 'div';

  return (
    <Component
      className={classSet({
        clickable: !item.isGlobalFillerChannel && permissions?.has(Permission.EditAsset),
        'no-clickable': item.isGlobalFillerChannel || !permissions?.has(Permission.EditAsset),
        'fuel-table-row--expired': item.item ? item.item.cssClassForExpired : false,
        'fuel-table-row--embargoed': item.item ? item.item.cssClassForEmbargoed : false,
      })}
      title={item.title}
      onClick={(event) => {
        if (onClick) onClick(event);
      }}
      to={href}
    >
      <div className="text-ellipses">{item.title}</div>
      {item.specialStatus && <Chip title={item.specialStatus} label={item.specialStatus} size="small" color="success" />}
    </Component>
  );
};

export default FuelAssetTitle;
